import React from 'react';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { SET_MODAL_STATUS } from 'store/actions';
function Success() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <>
            <Box className="modal-hero">
                <img src={AnnouncementImage} alt="announcement" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    Your payment has failed
                </Typography>
            </Box>
            <Box className="modal-footer pt-0">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            className="alternate w-full"
                            onClick={() => {
                                navigate('/dashboard');
                                dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                            }}
                        >
                            Back to dashboard
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default Success;
